import { FeatureIslandHeader } from "@/components/features/_layouts";

export const SettingsBillingHeader = () => {
	return <FeatureIslandHeader title="料金プランの設定" />;
};

SettingsBillingHeader.displayName = "SettingsBillingHeader";
